import React from 'react';
import { Route, Switch } from 'react-router-dom';
import TRM_Dashboard from '../pages/trm/typologyListingDashboard';
import TRM_Upload from '../pages/trm/typologyUploadDashboard';
import TRMConfiguration from '../pages/trm/systemConfiguration';
import TestScenarioDashboard from '../pages/trm/testRunInstanceDashboard';
import DetailedAlertInvestigation from '../pages/trm/detailedAlertInvestigation';
import { TM_FRAUD_SOURCE_IDS } from '../util/GlobalConstant';
import {
  isResourceAvailable,
  hasAttributeValueByAttributeKey
} from '../util/index';
import ConfigureInstanceDashboard from '../pages/trm/configureInstanceDashboard';
import MoveToProductionClass from '../pages/trm/moveInstanceToProduction';
import TicketsDashboard from '../pages/trm/ticketsDasboard';
import TicketDetailsPage from '../pages/trm/ticketDetail';
import Settings from '../pages/settings';
import smartAssessment from '../pages/trm/smartAssessment';
import framlAlertDetailRouter from '../pages/trm/smartAssessment/FramlAlertDetailRouter';
import DeployInProduction from '../pages/trm/deployInProduction/DeployInProduction';

import {
  TM_IAD_TAB_LIST,
  TM_IAD_TAB_PAGEID_LIST,
  CUSTOMER_MATCHING_TABL_LIST
} from '../pages/constants/trmConstants';

import '../pages/trm/mocks';
import { getSelectedResources } from '../util/resourceManager';
import NotFoundPage from '../pages/common/NotFoundPage';
import { getCurrentAppByPath } from '../pages/app/appUtils';
import SafeRedirect from './SafeRedirect';

const { trmResources } = getSelectedResources();

const TMIADSettings = () => (
  <Settings
    title="Global Setting for Transaction Monitoring IAD"
    title2="FRAML Detection Segments"
    tabList={TM_IAD_TAB_LIST}
    tabList2={CUSTOMER_MATCHING_TABL_LIST}
    tabPageIdList={TM_IAD_TAB_PAGEID_LIST}
    GlobalSettingPageType="TMIAD"
  />
);

export default (authentication) => {
  //protect route by user role
  const RestrictedRender = (Component, props = {}) => {
    //fix it once got resources
    return <Component {...props} />;
  };

  let homeUrl = null;

  let typologyListingPage = isResourceAvailable(
    authentication,
    trmResources.APP_3_RESOURCE_UI_TYPOLOGY
  );
  let typologyUploadPage = isResourceAvailable(
    authentication,
    trmResources.APP_3_RESOURCE_UI_TYPOLOGY_WRITE
  );
  let scenarioListingPage = isResourceAvailable(
    authentication,
    trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE
  );
  let deployInProduction =
    isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_AMLS_CHAMPION
    ) ||
    isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET_WRITE
    );
  let ticketListingPage =
    isResourceAvailable(
      authentication,
      trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET
    ) &&
    (hasAttributeValueByAttributeKey(
      authentication,
      trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET,
      'PRODUCT_SOURCE_ID',
      TM_FRAUD_SOURCE_IDS.FRAUD
    ) ||
      hasAttributeValueByAttributeKey(
        authentication,
        trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET,
        'PRODUCT_SOURCE_ID',
        TM_FRAUD_SOURCE_IDS.TM
      ) ||
      hasAttributeValueByAttributeKey(
        authentication,
        trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET,
        'PRODUCT_SOURCE_ID',
        TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID
      ));

  let ticketDetailPage = isResourceAvailable(
    authentication,
    trmResources.APP_3_RESOURCE_UI_AMLS_TM_TICKET_DETAILS
  );
  let globalSettingsPermitted = isResourceAvailable(
    authentication,
    trmResources.APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS
  );
  let systemConfigurationPage = false;

  if (typologyListingPage) {
    homeUrl = '/app/trm/dashboard';
  } else if (scenarioListingPage) {
    homeUrl = '/app/trm/run-instance';
  } else if (ticketListingPage) {
    homeUrl = '/app/trm/tickets';
  }
  // else{
  //   homeUrl = '/app/tm/investigation';
  // }

  const nameSpace = getCurrentAppByPath(location.pathname);

  const routes = (
    <Switch>
      {homeUrl && (
        <Route
          exact
          path="/app"
          render={({ history }) => (
            <SafeRedirect to={homeUrl} history={history} />
          )}
        />
      )}
      {homeUrl && (
        <Route
          exact
          path="/app/trm"
          render={({ history }) => (
            <SafeRedirect to={homeUrl} history={history} />
          )}
        />
      )}

      {deployInProduction && [
        <Route
          exact
          key={`/app/trm/deployInProduction/:scenarioId`}
          path={`/app/trm/deployInProduction/:scenarioId`}
          component={DeployInProduction}
        />,
        <Route
          exact
          key={`/app/trm/deployInProduction`}
          path={`/app/trm/deployInProduction`}
          component={DeployInProduction}
        />
      ]}

      {ticketDetailPage && (
        <Route
          exact
          path="/app/trm/ticketDetails/:id"
          render={(props) => {
            return RestrictedRender(TicketDetailsPage, props);
          }}
        />
      )}
      <Route
        exact
        path="/app/trm/configure/:id"
        render={(props) => {
          return RestrictedRender(ConfigureInstanceDashboard, props);
        }}
      />

      {globalSettingsPermitted && (
        <Route
          exact
          path="/app/trm/settings"
          render={() => {
            return RestrictedRender(TMIADSettings);
          }}
        />
      )}

      {ticketListingPage && (
        <Route
          exact
          path="/app/trm/tickets"
          render={(props) => {
            return RestrictedRender(TicketsDashboard, props);
          }}
        />
      )}

      <Route
        exact
        path="/app/trm/movetoproduction"
        render={(props) => {
          return RestrictedRender(MoveToProductionClass, props);
        }}
      />

      {typologyListingPage && (
        <Route
          exact
          path="/app/trm/dashboard"
          render={() => {
            return RestrictedRender(TRM_Dashboard);
          }}
        />
      )}

      {typologyUploadPage && (
        <Route
          exact
          path="/app/trm/upload"
          render={() => {
            return RestrictedRender(TRM_Upload);
          }}
        />
      )}

      {scenarioListingPage && (
        <>
          <Route
            exact
            path="/app/trm/run-instance"
            render={() => {
              return RestrictedRender(TestScenarioDashboard, {
                authentication
              });
            }}
          />
          <Route
            exact
            path="/app/trm/run-instance/:alertId"
            render={() => {
              return RestrictedRender(framlAlertDetailRouter);
            }}
          />
          <Route
            exact
            path="/app/trm/investigation/:alertId"
            render={() => {
              return RestrictedRender(DetailedAlertInvestigation);
            }}
          />
        </>
      )}

      {systemConfigurationPage && (
        <Route
          exact
          path="/app/trm/configuration"
          render={() => {
            return RestrictedRender(TRMConfiguration);
          }}
        />
      )}
      {nameSpace !== 'tm' ? <Route path="*" component={NotFoundPage} /> : null}
      <Route path="/app/trm/*" component={NotFoundPage} />
    </Switch>
  );
  return routes;
};
